/*
 * @Descripttion:
 * @Author: zhangtingjiang
 * @Date: 2019-12-10 13:49:36
 */
// let token = JSON.parse(localStorage.getItem('userInfo'))['Authentication-token']
let env = process.env.BASE_API ? process.env.BASE_API : 'http://api-dev.jkwwt.cn'
let hlepPath = `http://bz.jkwwt.cn?env=${env}`
export default {
  path: '/',
  name: 'help',
  hidden: true,
  component: () => import('@/views/Application'),
  children: [
    {
      path: hlepPath,
      name: 'helpPath',
      meta: {
        title: '系统使用手册',
        isLink: true,
        nav: 'helpPath',
        icon: 'fa fa-book iconTitle'
      },
      hidden: true
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/modules/router-help.js